import { Settings } from "../../../Settings";
import { SpinAndHoldCommonConfiguration } from "../../../api";
import { SpinAndHoldBonus } from "./SpinAndHold";
import { SpinAndHoldBonusPIXIAPP } from "./SpinAndHoldPIXIAPP";
import { SpinAndHoldBonusPIXIAPPResponsive } from "./SpinAndHoldPIXIAPPResponsive";
import { SpinAndHoldParams } from "./SpinAndHoldParams";

export interface ISpinAndHoldBonusFactory
{
	CreateSpinAndHoldBonus(gameName: string, params: SpinAndHoldParams, config: SpinAndHoldCommonConfiguration): SpinAndHoldBonus;
	CreateSpinAndHoldBonusPIXIApp(gameName: string, params: SpinAndHoldParams, config: SpinAndHoldCommonConfiguration): SpinAndHoldBonusPIXIAPP;
	CreateSpinAndHoldBonusPIXIAPPResponsive(gameName: string, params: SpinAndHoldParams, config: SpinAndHoldCommonConfiguration): SpinAndHoldBonusPIXIAPPResponsive;
}

export class SpinAndHoldBonusFactory implements ISpinAndHoldBonusFactory
{
	public CreateSpinAndHoldBonus(gameName: string, params: SpinAndHoldParams, config: SpinAndHoldCommonConfiguration): SpinAndHoldBonus
	{
		return new SpinAndHoldBonus(gameName, params, config);
	}
	
	public CreateSpinAndHoldBonusPIXIApp(gameName: string, params: SpinAndHoldParams, config: SpinAndHoldCommonConfiguration): SpinAndHoldBonusPIXIAPP|SpinAndHoldBonusPIXIAPPResponsive
	{
		return new SpinAndHoldBonusPIXIAPP(gameName, params, config);
	}

	public CreateSpinAndHoldBonusPIXIAPPResponsive(gameName: string, params: SpinAndHoldParams, config: SpinAndHoldCommonConfiguration): SpinAndHoldBonusPIXIAPPResponsive
	{
		return new SpinAndHoldBonusPIXIAPPResponsive(gameName, params, config);

	}
}